"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SocketDocumentChange_1 = __importDefault(require("./SocketDocumentChange"));
const utilities_1 = require("./utilities");
class SocketQuery {
    constructor(driver, id, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parent, descriptors = []) {
        this.driver = driver;
        this.id = id;
        this.parent = parent;
        this.descriptors = descriptors;
    }
    get path() {
        return this.parent ? `${this.parent.path}/${this.id}` : this.id;
    }
    chain(descriptor) {
        return new SocketQuery(this.driver, this.id, this.parent, [
            ...this.descriptors,
            descriptor,
        ]);
    }
    endAt(value) {
        return this.chain({ type: 'endAt', value });
    }
    endBefore(value) {
        return this.chain({ type: 'endBefore', value });
    }
    limit(limit) {
        return this.chain({ type: 'limit', limit });
    }
    orderBy(field, direction) {
        return this.chain({ type: 'orderBy', field, direction });
    }
    startAfter(value) {
        return this.chain({ type: 'startAfter', value });
    }
    startAt(value) {
        return this.chain({ type: 'startAt', value });
    }
    where(field, operator, value) {
        return this.chain({ type: 'where', field, operator, value });
    }
    async get() {
        const snapshot = await this.driver.request('queryGet', this.path, this.descriptors);
        const docs = snapshot.docs.map(doc => {
            const ref = utilities_1.getDoc(this.driver, doc.path);
            return new SocketDocumentChange_1.default(ref, doc.change, doc.data);
        });
        return {
            ref: this,
            docs,
        };
    }
    async onSnapshot(onNext) {
        const { subscriberId } = await this.driver.request('querySubscribe', this.path, this.descriptors);
        const event = `snapshot:${subscriberId}`;
        const listener = (snapshot) => {
            const docs = snapshot.docs.map(doc => {
                const ref = utilities_1.getDoc(this.driver, doc.path);
                return new SocketDocumentChange_1.default(ref, doc.change, doc.data);
            });
            onNext({
                ref: this,
                docs,
            });
        };
        this.driver.socket.on(event, listener);
        return async () => {
            this.driver.socket.off(event, listener);
            this.driver.request('unsubscribe', subscriberId);
        };
    }
}
exports.default = SocketQuery;
//# sourceMappingURL=SocketQuery.js.map